import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React,{useState} from 'react'
import portalServices from '../portalServices';
import { useAlert } from '../../../context/AlertContext';

function ReopenComplaint({complaint,calback}) {

    const [dialogStatus,setDialogStatus] = useState(false);
    const [reason,setReason] = useState("");
    const [saving,setSavingStatus] = useState("");  
    const {AppAlert} = useAlert()

    const reOpen = () =>{
        let payload ={
            complaintId:complaint.id,
            phone:complaint.phone,
            reason:reason
        }
        setSavingStatus(true)
        portalServices.reopenComplaint(payload).then(res=>{
            AppAlert("Your Request Reoppened")
            calback()
        }).catch((error)=>{
            AppAlert("Something Went Wrong Pleae Try Again","error")
        }).finally(()=>{
            setSavingStatus(false)
        })
    }

    return (
        <>
             {complaint.grievanceStatus === 3 && <button className='btn btn-sm btn-outline-danger ms-3' onClick={()=>setDialogStatus(true)}>Re Open</button> }
             <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogTitle>Reopen Complaint</DialogTitle>
                <DialogContent>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="mb-3">
                                <label className="form-label">Whay do you want to re open complaint</label>
                                <textarea  className="form-control" placeholder="Not Done / Partially Done" rows="3"
                                    value={reason}
                                    onChange={(e)=>setReason(e.target.value)}
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    {!saving ?
                        <button className='btn btn-primary' disabled={reason.length<4} onClick={reOpen} >Reopen</button>
                        :
                        <CircularProgress/>
                    }
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ReopenComplaint